import React from "react";
import "./Section3.css";
import SideImage from "../../../../../assets/images/taxplanningsec3-img1.png";
import Tick from "../../../../../assets/images/list-tick.png";
const Section3 = () => {
  return (
    <div className="taxplanningsrs3__section">
      <div className="taxplanningsrs3__section_left">
        <div className="taxplanningsrs3__secleft_heading">
          We help get you ahead by following curves
        </div>
        <div className="taxplanningsrs3__list_items">
          <div className="taxplanningsrs3__list_item">
            <img
              className="taxplanningsrs3__list_item_icon"
              src={Tick}
              alt=""
            />
            <div className="taxplanningsrs3__list_item_right">
              Retirement planning
            </div>
          </div>
          <div className="taxplanningsrs3__list_item">
            <img
              className="taxplanningsrs3__list_item_icon"
              src={Tick}
              alt=""
            />
            <div className="taxplanningsrs3__list_item_right">
              Estate planning
            </div>
          </div>
          <div className="taxplanningsrs3__list_item">
            <img
              className="taxplanningsrs3__list_item_icon"
              src={Tick}
              alt=""
            />
            <div className="taxplanningsrs3__list_item_right">
              Education planning
            </div>
          </div>
          <div className="taxplanningsrs3__list_item">
            <img
              className="taxplanningsrs3__list_item_icon"
              src={Tick}
              alt=""
            />
            <div className="taxplanningsrs3__list_item_right">
              Financial planning
            </div>
          </div>
          <div className="taxplanningsrs3__list_item">
            <div className="taxplanningsrs3__list_item_right">
              Our experienced staff can develop tax strategies that take
              advantage of new tax laws and legislation.
            </div>
          </div>
        </div>
      </div>
      <div className="taxplanningsrs3__section_right">
        <img src={SideImage} alt="" className="taxplanningsrs3__section_img" />
      </div>
    </div>
  );
};

export default Section3;
